import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { useTranslation } from "react-i18next";
import { FaBroom, FaHandsHelping, FaPlay, FaTruckMoving } from "react-icons/fa";
import "./HeroSection.scss";

const HeroSection = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();
  const heroBackground = `${process.env.PUBLIC_URL}/assets/img/slider/slider-bg-1.jpg`;

  const cards = useMemo(
    () => [
      {
        id: "cleaning",
        icon: FaBroom,
        title: t("HeroSection.cards.cleaning.title"),
        description: t("HeroSection.cards.cleaning.description"),
        cta: t("HeroSection.cards.cleaning.cta"),
      },
      {
        id: "moving",
        icon: FaTruckMoving,
        title: t("HeroSection.cards.moving.title"),
        description: t("HeroSection.cards.moving.description"),
        cta: t("HeroSection.cards.moving.cta"),
      },
      {
        id: "outsource",
        icon: FaHandsHelping,
        title: t("HeroSection.cards.outsource.title"),
        description: t("HeroSection.cards.outsource.description"),
        cta: t("HeroSection.cards.outsource.cta"),
      },
    ],
    [t]
  );

  return (
    <>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="o4GuSJYSzrY"
        onClose={() => setOpen(false)}
      />

      <section
        className="hero-section"
        id="home"
        style={{ "--hero-bg-image": `url(${heroBackground})` }}
      >
        <div className="container">
          <div className="row align-items-center gy-4 gy-lg-0">
            <div className="col-lg-5">
              <div className="hero-copy">
                <span className="hero-eyebrow">
                  {t("HeroSection.subtitle")}
                </span>
                <h1 className="hero-title">{t("HeroSection.title")}</h1>
                <p className="hero-description">
                  {t("HeroSection.description")}
                </p>
                <div className="hero-actions d-flex flex-wrap align-items-center gap-3">
                  <Link to="/quote" className="theme-btn text-white">
                    <i className="flaticon-enter"></i>{" "}
                    {t("HeroSection.primaryCta")}
                  </Link>
                  {/* <button
                    type="button"
                    className="hero-video-btn"
                    onClick={() => setOpen(true)}
                  >
                    <FaPlay className="me-2" />
                    {t("HeroSection.secondaryCta")}
                  </button> */}
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="hero-card-grid">
                {cards.map(({ id, icon: Icon, title, description, cta }) => (
                  <div key={id} className="hero-card">
                    <div className="hero-card-icon">
                      <Icon />
                    </div>
                    <h3 className="hero-card-title">{title}</h3>
                    <p className="hero-card-description">{description}</p>
                    {/* <Link to="/quote" className="hero-card-link">
                      {cta}
                    </Link> */}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
